import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Wrapper from '../wrapper'
import PaymentInfo from './PaymentInfo'
import License from './License'
import PaymentCard from './PaymentCard'
import PaymentMessage from './PaymentMessage'
import ConfirmActions from './ConfirmActions'
import PaymentNow from './PaymentNow'
import AddPaymentCardLegalUser from './AddPaymentCardLegalUser'

const styles = theme => ({
  paymentBox: {
    maxWidth: 380,
    marginLeft: 48,
    padding: '16px 26px',
    borderRadius: 8,
    position: 'relative',
    overflow: 'hidden',
  },
  paymentTitle: {
    marginBottom: 24,
    fontFamily: 'Roboto',
    fontSize: 8,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 2,
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
  },
})

export class Payment extends Component {
  state = {
    card: window.state.card,
    user: window.state.user,
    licenseExpired: window.state.licenseExpired,
    license: window.state.license,
    statusAutoPay: window.state.card && window.state.card.autoPay,
    statusCard: false,
    editCard: false,
    isLegal: window.state.isLegal,
  }

  getStatusAutoPay = status => {
    this.setState({
      statusAutoPay: status,
    })
  }

  getStatusCard = (status, statusEdit = false) => {
    this.setState({
      statusCard: status,
      editCard: statusEdit,
    })
  }

  deleteCard = () => {
    this.setState({
      card: null,
    })
  }

  editCard = status => {
    this.setState({
      editCard: status,
    })
  }

  render() {
    const {
      card,
      license,
      statusAutoPay,
      statusCard,
      editCard,
      licenseExpired,
      isLegal,
      user,
    } = this.state
    const { classes } = this.props
    if(!isLegal){
      return (
        <Wrapper shadow={1} className={classes.paymentBox}>
          <header className={classes.paymentTitle}>Платежи</header>

        <PaymentMessage
          card={card}
          license={license}
          statusAutoPay={statusAutoPay}
          user={user}
        />

          {card && statusAutoPay && licenseExpired && <PaymentNow />}

          <PaymentCard
            card={card}
            response={{
              getAutoPay: this.getStatusAutoPay,
              getStatusCard: this.getStatusCard,
              editCard: this.editCard,
            }}
          />

          <License license={license} />

          <PaymentInfo />

          <ConfirmActions
            response={{
              getStatusCard: this.getStatusCard,
              deleteCard: this.deleteCard,
            }}
            statusCard={statusCard}
            license={license}
            editCard={editCard}
          />
        </Wrapper>
      )
    }else{
      return (
        <Wrapper shadow={1} className={classes.paymentBox}>
          <header className={classes.paymentTitle}>Платежи</header>
          <AddPaymentCardLegalUser />
        </Wrapper>
      )
    }
  }
}

export default withStyles(styles)(Payment)
